import React from 'react'
import { Modal, Pressable, StyleSheet } from 'react-native'

import { B2, Button, H4, Stack, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { CancellationConfirmationModalProps } from '@zet/zet-prime'
import { Image } from 'expo-image'

// @ts-ignore - TypeScript server issue with Button component
const ButtonComponent = Button as any

const CancellationConfirmationModal = ({
  isVisible,
  onClose,
  onWithdrawRequest,
  subscriptionEndDate,
}: CancellationConfirmationModalProps) => {
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <Pressable style={styles.modalOverlay} onPress={onClose}>
        <Pressable
          style={styles.modalContent}
          onPress={(event) => event.stopPropagation()}
        >
          <Stack className="items-center py-4">
            <Image
              style={styles.sadEmoji}
              source={require('@zet/zet-prime/assets/images/sadEmoji.png')}
              contentFit="contain"
            />

            <H4 className="text-center my-2 text-grays-80 font-bold  px-4">
              {i18n.t(
                'zetPrime.yourRequestToCancelSubscriptionHasBeenReceived',
              )}
            </H4>

            <B2 className="text-center text-orange-500 font-normal px-2 mb-4">
              {i18n.t('zetPrime.currentSubscriptionEndsOn', {
                subscriptionEndDate,
              })}
            </B2>

            <XStack className="items-center justify-between border-t border-primary-20 pt-3 px-4">
              <Button size="large" textOnly={true} onPress={onClose}>
                {i18n.t('zetPrime.gotIt')}
              </Button>
              <Button
                size="large"
                className={'py-2'}
                onPress={onWithdrawRequest}
              >
                {i18n.t('zetPrime.withdrawRequest')}
              </Button>
            </XStack>
          </Stack>
        </Pressable>
      </Pressable>
    </Modal>
  )
}

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 0,
    width: '100%',
    maxWidth: 400,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 5,
  },
  sadEmoji: {
    width: 64,
    height: 64,
  },
})

export default CancellationConfirmationModal
